export const isSegmentationExperimentOn = abTests => {
  return abTests && abTests.indexOf('create-seg_enabled') > -1
}

export const isAccountRevalidationExperimentOn = abTests => {
  return abTests && abTests.indexOf('reval-log_enabled') > -1
}

export const isStrongPasswordExperimentOn = abTests => {
  return abTests && abTests.indexOf('pass-lvl_enabled') > -1
}

export const isModalLoginEnabled = abTests => {
  return (
    abTests && (abTests.indexOf('mod-log_enabled') > -1 || abTests.indexOf('mod-log_token') > -1)
  )
}

export const getModalLoginExtraData = (abTests, modalMode = false) => {
  return modalMode && isModalLoginEnabled(abTests) ? { from_modal: true } : {}
}

export const isLoginScrollEnabled = abTests => {
  return abTests && abTests.indexOf('log-rdsgn_enabled') > -1
}

export const isCheckIdentifierExperimentOn = abTests => {
  return abTests && abTests.indexOf('check-id_enabled') > -1
}
